<script setup lang="ts">
import ChatMenu from "@/views/Home/components/ChatMenu.vue";
import { computed, defineProps, toRefs, defineEmits } from "vue";
import {
  showEditChatTitleDialogue,
  editForm,
} from "@/components/Dialogues/useData/useDialogues";
import { deleteDialogue } from "@/views/Home/useData/module/dialogue";

const props = defineProps({
  sessionItem: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    required: true,
  },
});

const { sessionItem, isSelected, index } = toRefs(props);

const dialogueAction = (_index: number) => {
  // 0 edit 1 remove
  if (_index == 0) {
    editForm.index = index?.value;
    editForm.content = sessionItem.value.title;
    console.log("edit", editForm);
    showEditChatTitleDialogue.value = true;
  } else {
    deleteDialogue(index?.value);
  }
};

const emits = defineEmits(["changeDialogue"]);

const changeDialogue = () => {
  emits("changeDialogue");
};
</script>

<template>
  <div
    class="item-base"
    :class="{
      selected: isSelected,
    }"
  >
    <div class="left" @click.stop="changeDialogue">
      {{ sessionItem.title }}
    </div>
    <div class="right">
      <el-popover
        placement="bottom"
        :width="200"
        trigger="click"
        :show-arrow="false"
      >
        <template #reference>
          <div class="more">
            <el-icon><MoreFilled /></el-icon>
          </div>
        </template>
        <ChatMenu @dialogueAction="dialogueAction" />
      </el-popover>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item-base {
  width: 100%;
  height: 38px;
  background: #f9fbff;
  cursor: pointer;
  border-radius: 12px;

  &:hover {
    background-color: #dbeafe;
  }
  padding: 0 12px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;

  .left {
    height: 100%;
    padding-top: 2px;
    // padding-bottom: 8px;
    flex: 1;
    font-size: 14px;
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    -webkit-box-orient: vertical; /* 垂直方向排列 */
    -webkit-line-clamp: 1;
    line-clamp: 1;
    line-height: 36px;
  }

  .right {
    height: 100%;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    .more {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      padding: 2px;

      &:hover {
        background-color: #fff;
      }
    }
  }
}

.selected {
  background-color: #dbeafe;
}
</style>
